module.exports = __webpack_public_path__ + "static/media/computas_logo.d24e16b3.svg";